module.exports = __webpack_public_path__ + "static/img/47.4ac97da.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/47.gif
// module id = lZbv
// module chunks = 0